var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"make-an-entry-visibility"},[_c('BIcon',{attrs:{"icon":"lock"}}),_c('span',{staticClass:"has-text-grey is-size-7"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }